
import { defineComponent } from "vue";
import "@/assets/scss/patient/records.scss";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import LoadingScreen from "@/components/LoadingScreen.vue";

import axios from "axios";

export default defineComponent({
  components: {
    LoadingScreen,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "records",
  props: ["id"],
  data() {
    return {
      active: false,
      isLoading: true,
      showImage: true,
      records: [],
      images: [],
      slides: [],
      links: [
        // {
        //   text: "",
        //   disabled: false,
        //   href: "/doctor/patients",
        // },
        {
          text: "بیماران",
          disabled: true,
          href: "/doctor/patients",
        },
        {
          text: "آزمایش ها",
          disabled: true,
          href: "/doctor/patients-records",
        },
      ],
    };
  },
  methods: {
    back() {
      this.$router.push("/doctor/patients");
    },
    fetchRecordes() {
      axios
        .get(`doctor/patients/${this.id}/slides`)
        .then((res) => {
          console.log(res);
          // console.log(res.data.map((x: any) => x.images.map((x: any) => x.id)));
          this.records = res.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    show(index: number) {
      this.slides = this.records[index];
      this.active = true;
    },
    zoom(path: string) {
      window.open(path);
    },
    imageSimple() {
      this.showImage = true;
    },
    imageLable() {
      this.showImage = false;
    },
  },
  mounted() {
    this.fetchRecordes();
  },
});
